import SipThemeProvider from './SipThemeProvider'

export default SipThemeProvider
